export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'ServiceDueDetails';
export const NAME = 'ServiceDueDetails';

export const MAX_DAYS = 90;
